import React, { useState, useEffect } from "react";
import FoodService from "../../services/FoodService";
import { motion } from "motion/react";
const ListDrink = () => {
  const [fooddrink, setFoodDrink] = useState([]);
  const isEven = (num) => num % 2 === 0;
  useEffect(() => {
    retrieveFood();
  }, []);

  const retrieveFood = () => {
    FoodService.getAlldrinks()
      .then((response) => {
        const newValue = [];
        const datas = response.data;
        // console.log(datas)
        // datas.forEach(data => {
        //   data['image']=JSON.parse(data['image'])

        //   newValue.push(data)
        // });
        setFoodDrink(datas);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <>
      <div className="pb-10  bg-slate-100 w-full">
        <div className="flex flex-row-2 w-full h-16 text-center relative gap-y-80">
          <h1 className="text-4xl lg:text-4xl font-semibold px-10 pt-10">
            Drinks List
          </h1>

          <button
            className="bg-blue-500 hover:bg-blue-400 text-white font-bold py-2 px-4 border-b-4 border-blue-700
      hover:border-blue-500 rounded  absolute top-10 right-0"
          >
            <a
              href={"/admin/fooddrink/add"}
              className="lg:text-1xl"
            >
              Add New Item
            </a>
          </button>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2">
          {fooddrink &&
            fooddrink.map((menu, index) => (
              <div
                className="m-2 p-8 "
                key={index}
              >
                <motion.h1
                  initial={{ x: 100, opacity: 0 }}
                  viewport={{ once: true }}
                  whileInView={{
                    x: 0,
                    opacity: 1,
                    transition: {
                      delay: 0.5,
                      x: { type: "spring", stiffness: 60 },
                      opacity: { duration: 0.6 },
                      ease: "easeIn",
                    },
                  }}
                  className="text-2xl lg:text-2xl font-semibold"
                >
                  {menu.name}
                </motion.h1>

                <motion.div
                  initial={{ x: 100, opacity: 0 }}
                  viewport={{ once: true }}
                  whileInView={{
                    x: 0,
                    opacity: 1,
                    transition: {
                      delay: 0.5,
                      x: { type: "spring", stiffness: 60 },
                      opacity: { duration: 0.6 },
                      ease: "easeIn",
                    },
                  }}
                  className="relative flex flex-col my-6 bg-white shadow-sm border border-slate-200 rounded-lg w-full"
                >
                  <div className="p-4">
                    <div className="divide-y divide-slate-200">
                      <table className="table-auto w-full border-spacing-2 ">
                        <tbody>
                          {menu.items?.length > 0 &&
                            menu.items.map((menuitem, index) => (
                              <tr key={index}>
                                <td className="w-3/4 border-separate border-b-[0.3px] border-slate-500 py-4">
                                  <div>
                                    <h6 className="text-slate-800 font-semibold">
                                      {menuitem.name}
                                    </h6>
                                    <p
                                      className="text-slate-600 text-sm"
                                      dangerouslySetInnerHTML={{
                                        __html: menuitem.description,
                                      }}
                                    />
                                  </div>
                                </td>
                                <td className="border-separate border-b-[0.3px] border-slate-500 py-4">
                                  <h6 className="text-slate-600 font-medium">
                                    ${menuitem.price}
                                  </h6>
                                </td>
                                <td className="order-last border-separate border-b-[0.3px] py-4  border-slate-500">
                                  <a href={"/admin/fooddrink/" + menuitem.id}>
                                    <button className="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded">
                                      Edit
                                    </button>
                                  </a>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </motion.div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default ListDrink;
